import { useQuery } from 'react-query'
import { authNational } from 'services/auth_national'

export default function useGetKyc() {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['kyc'],
        queryFn: () => authNational(''),
    })
    return { data, isLoading, error, refetch }
}
